import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const LOGO_URL = "/livrum-logo.webp";

const Header = ({ dark = false }) => {
  const navigate = useNavigate();

  return (
    <header className={`nav-header${dark ? ' nav-header-dark' : ''}`}>
      {/* Logo */}
      <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')} style={{ position: 'relative', zIndex: 10 }}>
        <img 
          src={dark ? '/livrum-logo-light.webp' : LOGO_URL} 
          alt="Livrum" 
          style={{ height: dark ? '40px' : '54px', width: 'auto' }}
          data-testid="header-logo"
        />
      </div>

      {/* Center text */}
      <div className="header-center-text">
        <span className="text-secondary text-sm font-medium">
          Plataforma de publicação digital para editores
        </span>
      </div>

      {/* Auth buttons */}
      <div className="flex items-center gap-3">
        <Button 
          variant="ghost" 
          className="btn-secondary-custom"
          onClick={() => navigate('/cadastro')}
          data-testid="header-signup-btn"
        >
          Cadastre-se
        </Button>
        <Button 
          className="btn-primary-custom"
          onClick={() => navigate('/login')}
          data-testid="header-login-btn"
        >
          Login
        </Button>
      </div>
    </header>
  );
};

export default Header;
